/* eslint-disable jsx-a11y/anchor-is-valid */
import {Pagination} from "common/Pagination"
import {RegisterDevice} from "pages/admin/devices/form/RegisterDevice"
import {useDeleteRealDeviceMutation, useFindAllRealDevice} from "hooks/queries/real-device.query"
import {useRootStore} from "store/useRootStore"
import {observer} from "mobx-react"
import "rc-tree/assets/index.css"

import {DeviceStatusTagClassName, RealDevice, SensorStatus} from "dto/realdevice/devices"
import {UpdateDevice} from "pages/admin/devices/form/UpdateDevice"
import {
    GridTableColumn,
    GridTableHeaderWrapper,
    GridTableListItemWrapper
} from "pages/admin/common/common-style-component"
import {StatusTag} from "pages/dashboard/wheelchair/WheelchairListItems"
import CategoryView from "pages/admin/devices/CategoryView"
import {Category} from "dto/category/category"
import {useFindAllCategories} from "hooks/queries/category.query"
import {RealDeviceApi} from "../../../api/real-device";
import ReactDatePicker from "react-datepicker";
import {useState} from "react";
import dayjs from "dayjs";

export const RealDeviceList = observer(() => {
    // const [showRegisterDeviceWindow, setShowRegisterDeviceWindow] = useState(false)
    const [searchDate, setSearchDate] = useState(dayjs().toDate())
    const {
        adminStore: {
            realDeviceStore: {
                showRegisterDeviceWindow,
                setShowRegisterDeviceWindow,
                page,
                setPage,
                size,
                keyword,
                setKeyword,
                selectedDevice,
                selectDevice,
                selectedCategory
            }
        }
    } = useRootStore()
    const registerDevice = () => {
        setShowRegisterDeviceWindow(true)
    }

    return (
        <div className="admin-container">
            <div className="level ">
                <div className="level-left">
                    <h5 className="is-size-3 has-text-weight-bold">장비(단말기정보)</h5>
                </div>
                <div className="level-right flex">
                    <div className="btn btn-primary mr-2 mt-2" onClick={async () => {
                        await RealDeviceApi.downloadExcel()
                    }}>단말정보 엑셀다운로드</div>
                    <ReactDatePicker
                        selected={searchDate}
                        onChange={(date: Date) => {
                            setSearchDate(date)
                        }}
                        className="input group-input"
                        placeholderText="시작일"
                        dateFormat="yyyy년 MM월 dd일"
                    />
                    <div className="btn btn-primary mr-2 mt-2" onClick={async () => {
                        await RealDeviceApi.downloadDeviceStatusExcel(searchDate)
                    }}>단말상태 엑셀다운로드</div>
                    <div className="level-item input-search-box5">
                        <div className="btn-search">
                            <i className="fa fa-search has-text-info"/>
                        </div>
                        <input className="input" type="text" placeholder="단말기검색"
                               value={keyword} onChange={e => setKeyword(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div className="admin-panel admin-body is-flex">
                <div className="is-flex-shrink-1 pr-2" style={{width: 200}}>
                    <CategoryView/>
                </div>
                <div className="is-flex-grow-1">
                    <DeviceListView keyword={keyword} page={page} size={size} setPage={setPage}
                                    selectDevice={selectDevice}
                                    selectedCategory={selectedCategory}
                    />
                    <div>
                        <button className="button is-success" onClick={registerDevice}>단말기(휠체어등록)</button>
                        {/*<button className="button is-dark ml-1">삭제</button>*/}
                    </div>
                </div>
            </div>

            {showRegisterDeviceWindow && (
                <RegisterDevice show={showRegisterDeviceWindow}
                                close={() => setShowRegisterDeviceWindow(false)}
                                title="휠체어(단말기) 등록하기"/>)
            }
            {selectedDevice && (
                <UpdateDevice show={true} close={() => selectDevice(undefined)} device={selectedDevice}/>
            )}
        </div>
    )
})

const GRID_TEMPLATE_COLUMNS = "5% 10% 9% 10% 10% 10% auto 5% 5%"
const DeviceListView = ({
                            keyword,
                            page,
                            size,
                            setPage,
                            selectDevice,
                            selectedCategory
                        }: {
    keyword?: string, page: number, size: number, setPage: (page: number) => void, selectDevice: (device: RealDevice) => void, selectedCategory: Category| undefined
}) => {
    const {data: response} = useFindAllRealDevice()
    const deleteDeviceMutation = useDeleteRealDeviceMutation()

    const categories = ((useFindAllCategories()?.data || [] ) as Category[]).reduce<Map<number, Category>>((acc, prev) => {
        acc.set(prev.id || 0, prev)
        return acc
    }, new Map<number, Category>())
    const deleteDevice = (id: number) => {
        if (!window.confirm("삭제 하시겠습니까?")) return
        deleteDeviceMutation.mutate(id)
    }


    console.log("device list : ", response)
    const originList = response?.filter(device => {
        if (!keyword) return true
        return device.name.includes(keyword) || device.communicationDevice.eui.includes(keyword)
    }).filter(device => {
        if (!selectedCategory || selectedCategory.id === 0) return true
        if(selectedCategory.level === "CITY") {
            return selectedCategory.children?.some(category => category.id === device.category?.id)
        } else {
            return selectedCategory.id  === device.category?.id
        }
    }) || []

    const sliceOffset = page * size
    const deviceList = originList.slice(sliceOffset, sliceOffset + size) || []
    // const numberOfElements = response?.length || 0
    const numberOfElements = originList.length || 0
    return (
        <div>
            <GridTableHeaderWrapper gridTemplateColumns={GRID_TEMPLATE_COLUMNS} className="mt10">
                <GridTableColumn>순번</GridTableColumn>
                <GridTableColumn>장비명(ID)</GridTableColumn>
                <GridTableColumn>장비상태</GridTableColumn>
                <GridTableColumn>카테고리</GridTableColumn>
                <GridTableColumn>사용자명</GridTableColumn>
                <GridTableColumn>연락처</GridTableColumn>
                <GridTableColumn>주소</GridTableColumn>
                <GridTableColumn>수정</GridTableColumn>
                <GridTableColumn>삭제</GridTableColumn>
            </GridTableHeaderWrapper>
            {deviceList.length === 0 && (
                <GridTableListItemWrapper gridTemplateColumns="100%">
                    <GridTableColumn>등록된 장비(단말기)가 없습니다.</GridTableColumn>
                </GridTableListItemWrapper>
            )}
            {deviceList.map((device, idx) => {
                const rowNumber = ((page * size) + idx) + 1
                const statusTagClassName = DeviceStatusTagClassName[device.communicationDevice.status || 'STAND_BY']
                const status = device.communicationDevice.status || 'STAND_BY'
                const sensorStatus = device.communicationDevice.sensorStatus || {} as SensorStatus
                const categoryName = device.category?.id ? categories.get(device.category?.id)?.name : undefined
                return (
                    <GridTableListItemWrapper key={device.id} gridTemplateColumns={GRID_TEMPLATE_COLUMNS}>
                        <GridTableColumn>
                            {rowNumber}
                        </GridTableColumn>
                        <GridTableColumn>{device.communicationDevice.eui}</GridTableColumn>
                        <GridTableColumn>
                            <StatusTag stat={status} sensorStatus={sensorStatus} isSmall={true}/>
                        </GridTableColumn>
                        <GridTableColumn>{categoryName}</GridTableColumn>
                        <GridTableColumn>{device.name}</GridTableColumn>
                        <GridTableColumn>{device.mobile?.phoneNumber}</GridTableColumn>
                        <GridTableColumn
                        >{device.address?.address} {device.address?.subAddress}</GridTableColumn>
                        <GridTableColumn>
                            <a className="button is-info is-size-85 is-rounded mt10"
                               onClick={() => selectDevice(device)}>수정</a>
                        </GridTableColumn>
                        <GridTableColumn>
                            <a className="button is-danger is-size-85 is-rounded mt10"
                               onClick={() => deleteDevice(device.id || 0)}>삭제</a>
                        </GridTableColumn>
                    </GridTableListItemWrapper>
                )
            })}
            <Pagination changePage={(page: number) => {
                setPage(page - 1)
            }} total={numberOfElements} size={size} page={page + 1}/>
        </div>
    )
}